import isWalkInSlotAvailable from "./isWalkInSlotAvailable";
import type { DiscountAvailabilityStrategy } from "../../../utils/discountAvailability";

/**
 * Walk-in slot rules for the shared discount derive pipeline.
 * Removable with `model/walkIn`.
 */
export const walkInDiscountAvailabilityStrategy: DiscountAvailabilityStrategy =
  {
    modeKey: "walkIn",
    includeSlot: (slot) => slot.walkInsEnabled === true,
    isSlotAvailable: (slot, people) => isWalkInSlotAvailable(slot, people),
    getDinersAvailable: (slot) => slot.walkInDinersAvailable,
  };
